import React from 'react';
import axios from 'axios';
import { getLoginPersistanceTimeout } from '../../constants/Constants';
import { useAppDispatch } from '../../store/Hooks';
import { fetchTeacher, teacherAuthStateSwap } from '../../store/TeacherSlice';
import { setAxiosAuthToken } from '../../utils/AuthServices';
import { Redirect } from 'react-router';


function Signup() {
    const dispatch = useAppDispatch()
    const [password, setPassword] = React.useState('')
    const [keyValue, setKeyValue] = React.useState('')
    const [passwordConfirm, setPasswordConfirm] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [passwordCheck, setPasswordCheck] = React.useState(false)
    const [isRegistered, setIsRegistered] = React.useState(false)
    const isFirstRender = React.useRef(true)
    const userId = React.useRef(NaN)
    const [errorClass, setErrorClass] = React.useState("hidden");

    React.useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
        getUserTypeDataToState();
        dispatch(teacherAuthStateSwap(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRegistered]);

    const getUserTypeDataToState = () => {
        dispatch(fetchTeacher(userId.current));
    }

    const handleChange = (event: any) => {
        if (event.target.name === 'email') {
            setEmail(event.target.value)
        } else if (event.target.name === 'password') {
            setPassword(event.target.value)
        } else if (event.target.name === 'passwordConfirm') {
            setPasswordConfirm(event.target.value)
        } else if (event.target.name === 'keyValue') {
            setKeyValue(event.target.value)
        }
    }

    const comparePasswords = (event: any) => {
        if (event.target.name === 'passwordConfirm' && event.target.value === password) {
            setPasswordCheck(true)
        } else if (event.target.name === 'passwordConfirm') {
            alert('Varmista, että salasanat vastaavat toisiaan.'); setPasswordConfirm(''); setPassword('');
        }
        if (event.target.name === 'keyValue' && event.target.value !== 'Vikkeharjoitus') {
            alert('Väärä avainkoodi.'); setKeyValue('');
        }
    }

    const handleSubmit = (event: any) => {
        let registerURL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/teachers/' : '/api/teachers/'
        event.preventDefault();
        axios.post(registerURL, {
            username: email,
            password: password,
            email: email,
        })
            .then((response) => {
                userId.current = response.data.id
                let authURL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/token-auth/' : '/api/token-auth/'
                axios.post(authURL, {
                    username: email,
                    password: password
                })
                    .then((response2) => {
                        const auth_token = response2.data.token
                        const currentDate = new Date();
                        const persistanceHours: number = getLoginPersistanceTimeout()
                        currentDate.setHours(currentDate.getHours() + persistanceHours); //Determines how long the user will remain logged in even after leaving the site or refreshing it.
                        setAxiosAuthToken(auth_token)
                        localStorage.setItem('access_token', JSON.stringify(auth_token))
                        localStorage.setItem('user_id', response2.data.user_id)
                        localStorage.setItem('user_type', response2.data.user_groups[0].name)
                        localStorage.setItem('login_time', JSON.stringify(currentDate))
                        let licenceURL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/licence/' : '/api/licence/'
                        axios.post(licenceURL, {
                            name: 'vikkeharjoitus_' + email,
                            teachers: userId.current,
                        })
                            .then(() => {
                                setIsRegistered(true)
                            })
                    }, (error) => {
                        console.log(error)
                        setIsRegistered(false)
                        setErrorClass("text-xs text-red-500")
                    })
            }, (error) => {
                console.log(error)
                setIsRegistered(false)
                setErrorClass("text-xs text-red-500")
            })
    }

    const signupContent = <div className="flex flex-grow mt-20">
        <div className="max-w-2/5 w-full space-y-8 mx-auto">
            <div>
                <img className="mx-auto h-12 w-auto" src="logo_musta.png" alt="Vikke" />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Rekisteröidy käyttäjäksi</h2>
            </div>
            <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={handleSubmit}>
                <input type="hidden" name="remember" value="true" />
                <div className="rounded-md shadow-sm -space-y-px">
                    <div>
                        <label htmlFor="email-address" className="sr-only">Sähköposti</label>
                        <input value={email} onChange={handleChange} id="email-address" name="email" type="email" autoComplete="email" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Käyttäjätunnus" />
                    </div>
                    <div>
                        <label htmlFor="password" className="sr-only">Salasana</label>
                        <input value={password} onChange={handleChange} id="password" name="password" type="password" autoComplete="current-password" required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Salasana" />
                    </div>
                    <div>
                        <label htmlFor="password" className="sr-only">Salasana uudestaan</label>
                        <input value={passwordConfirm} onChange={handleChange} onBlur={comparePasswords} id="passwordConfirm" name="passwordConfirm" type="password" autoComplete='off' required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Salasana uudestaan" />
                    </div>
                    <div>
                        <label htmlFor="checkValue" className="sr-only">Avainkoodi</label>
                        <input value={keyValue} onChange={handleChange} onBlur={comparePasswords} id="keyValue" name="keyValue" type="password" autoComplete='off' required className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm" placeholder="Avainkoodi" />
                    </div>
                </div>
                <div>
                    <button type="submit" value="Submit" disabled={!passwordCheck} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                        <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                            <svg className="h-5 w-5 text-teal-500 group-hover:text-teal-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                            </svg>
                        </span>
                        Rekisteröidy
                    </button>
                </div>
            </form>
            <div>
                <a href="/login">Kirjaudu</a>
            </div>
            <div className={errorClass}>Rekisteröityminen epäonnistui.</div>
        </div>
    </div>

    const routingLogic = () => {
        if (isRegistered) {
            return <Redirect to='/teacher/' />
        } else {
            return signupContent
        }
    }
    let routeView: JSX.Element = routingLogic()

    return (
        <>{routeView}</>
    )
}


export default Signup;